import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { AccentDescription, StatusDescription } from '../../../styled'
import { InputWrapper, TextWrapper } from '../../styled'
import { AButton } from 'views/components/Analytics'
import { SignBodyProps } from '../types'
import { useAProgress } from 'hooks/useAProgress'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { Label, Value } from '../styled'
import { usePermissions } from 'views/components/PermissionCheck/usePermissions'
import { ApprovalStatus, isApprovalStatusAfter } from 'modules/domain/deal/types'

export const ApprovedByExecutiveDirector: FC<SignBodyProps> = ({ isDone, deal, dealRefetch }) => {
  const { t } = useTranslation('deal')

  const hasPerms = usePermissions(['deals.executive_director_approval'])
  const readyToSign = isApprovalStatusAfter(deal.approval_status, ApprovalStatus.APPROVED_BY_COMMERCIAL_DIRECTOR)

  const [signProgress, signHandler] = useAProgress(
    () =>
      apiClient.post(endpoints.dealChangeApprovalStatus(deal.id), {
        new_approval_status: ApprovalStatus.APPROVED_BY_EXECUTIVE_DIRECTOR,
      }),
    { eventName: 'approved_by_executive_director', onSuccess: () => dealRefetch() },
  )
  const [requestProgress, requestSign] = useAProgress(() => apiClient.post(endpoints.dealRequestSign(deal.id)), {
    eventName: 'requestSign',
    onSuccess: () => dealRefetch(),
  })

  if (isDone) {
    return (
      <TextWrapper>
        <StatusDescription $isDone={isDone}>
          {t('contractSign.status')}{' '}
          <AccentDescription $isDone={isDone}>{t('contractSign.statusSigned')}</AccentDescription>
        </StatusDescription>
      </TextWrapper>
    )
  }
  let status = t('contractSign.signStatus.requestRequired')
  if (deal.is_signing_requested) {
    status = t('contractSign.signStatus.wating')
  }

  return (
    <InputWrapper>
      <div>
        <Label>{`${t('contractSign.status')}:`}</Label>
        &nbsp;
        <Value>{status}</Value>
      </div>
      <div>
        {!deal.is_signing_requested && !hasPerms && (
          <AButton id="contractSign" onClick={requestSign} color="primary" size="medium" progress={requestProgress}>
            {t('contractSign.requestSign')}
          </AButton>
        )}
        {readyToSign && hasPerms && (
          <AButton id="contractSign" onClick={signHandler} color="primary" size="medium" progress={signProgress}>
            {t('contractSign.sign')}
          </AButton>
        )}
      </div>
    </InputWrapper>
  )
}
